export type QueryStatus = 'idle' | 'loading' | 'success' | 'error';

export interface QueryStateBase<T> {
  data: T;
  status: QueryStatus;
  isFetching: boolean;
  error: unknown;
}

export interface QueryState<T> extends QueryStateBase<T> {
  lastSync: Date | null;
}

export function createQueryState<T>(defaultData: T): QueryState<T> {
  return {
    data: defaultData,
    status: 'idle',
    isFetching: false,
    error: null,
    lastSync: null,
  };
}

export function setQueryLoading<T>(query: QueryStateBase<T>): Partial<QueryStateBase<T>> {
  return {
    status: query.status === 'success' ? 'success' : 'loading',
    isFetching: true,
    error: null,
  };
}

export function setQuerySuccess<T>(data: T): Partial<QueryStateBase<T>> {
  return {
    data,
    status: 'success',
    isFetching: false,
    error: null,
  };
}

export function setQueryError(error: unknown): Pick<QueryStateBase<unknown>, 'status' | 'isFetching' | 'error'> {
  return {
    status: 'error',
    isFetching: false,
    error,
  };
}

export function isQueryLoading<T>(query: QueryStateBase<T>): boolean {
  return query.status === 'idle' || query.status === 'loading';
}

export function isQueryFetching<T>(query: QueryStateBase<T>): boolean {
  return query.isFetching;
}
